import { render, staticRenderFns } from "./CreateRoleModal.vue?vue&type=template&id=4b3e6384&scoped=true&"
import script from "./CreateRoleModal.vue?vue&type=script&lang=js&"
export * from "./CreateRoleModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3e6384",
  null
  
)

export default component.exports